import { useSyncExternalStore } from "react";
import { useSession } from "./session.js";
import type { AppState } from "./store.js";

/** Subscribes a component to the realtime-derived app state. */
export function useAppState(): AppState {
  const { store } = useSession();
  return useSyncExternalStore(store.subscribe, store.getState);
}
